<template>
  <div class="container">
    <p class="text large-text">
      Möchten Sie zusätzlich die wiederverwendbaren
      Bettschutzeinlagen für 0€ erhalten?
    </p>

    <div class="image-container">
      <v-img
          src="https://storage.googleapis.com/builder.zenflow.de/hysana/www/assets/f0a9c949-52a4-4dc4-8233-4d46449eef6a.webp"
          contain
          height="300px"
          width="400px">
      </v-img>
    </div>


    <p class="text">
      Bis zu 6 Stück pro Jahr (jährliche Lieferung)
    </p>
    <p class="text highlighted">
      Diese Bettschutzeinlagen können bis zu <span class="highlight">300</span> Mal gewaschen werden.
    </p>

    <v-btn color="gradient-primary" class="button mb-8" @click="selectBettschutz" x-large>
      Weiter mit Bettschutz
      <v-icon right>mdi-arrow-right</v-icon>
    </v-btn>

    <v-btn color="secondary" class="button secondary-button" x-large @click="$router.push('/dateneingabe')">
      Weiter ohne Bettschutz
    </v-btn>

  </div>
</template>

<script>
import {mapMutations} from "vuex";

export default {
  methods: {
    ...mapMutations(["increase"]),

    selectBettschutz() {
      this.increase('WB');
      this.$router.push('/dateneingabe');
    }
  }
}
</script>

<style scoped>

.gradient-primary {
  background: linear-gradient(315deg, #f9ad18, #f98918 80%);
  color: white; /* Setzen Sie eine Farbe für den Text, die gut mit dem Gradienten harmoniert */
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80vh;
  padding: 50px 20px;
  font-family: 'Helvetica Neue', Arial, sans-serif;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 60%;
  overflow: hidden;
}


.text {
  font-size: 24px;
  margin: 15px 0;
  color: #333;
}

.large-text {
  font-size: 28px;
  font-weight: 500;
  margin-bottom: 10px;
}

.highlight {
  font-weight: bold;
  color: IhrePrimäreFarbe;
}

.button {
  font-size: 18px;
  border-radius: 5px;
  transition: all 0.3s;
}


.link-button {
  margin-top: 20px;
  color: #888;
  font-size: 16px;
}

</style>
